export default "__VITE_ASSET__DlIGangU__"